import { Form, Typography } from 'antd'
import { FC } from 'react'
import {
    formatMileageDisplay,
    materialLengthKmToMeters,
    sumMaterialConsumptionLengthKm,
    toMeters,
} from '../../../helpers/consumption-helpers'
import { getValidMaterialConsumptions } from '../../../helpers/consumption-form-values'
import { ConsumptionFormValues } from '../types'

const MachineCounterPreview: FC = () => {
    const form = Form.useFormInstance<ConsumptionFormValues>()
    const materials = Form.useWatch('materials', form) || []
    const machineCounters = Form.useWatch('machineCounters', form) || []
    const savedSnapshot = toMeters(Form.useWatch('savedMachineCounter', form))
    const initialConsumption = toMeters(Form.useWatch('initialConsumptionMeters', form))
    const primaryMachine = machineCounters[0]

    const incrementMeters = materialLengthKmToMeters(
        sumMaterialConsumptionLengthKm(getValidMaterialConsumptions(materials))
    )
    const baseMeters = toMeters(primaryMachine?.currentCounter)

    if (!primaryMachine || !incrementMeters) return null

    const totalMeters = savedSnapshot
        ? savedSnapshot + Math.max(0, incrementMeters - initialConsumption)
        : baseMeters + incrementMeters

    return (
        <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Пробеги станков</div>
            <Typography.Text>{formatMileageDisplay(totalMeters, incrementMeters)}</Typography.Text>
        </div>
    )
}

export default MachineCounterPreview